module.exports = __webpack_public_path__ + "img/hybrid-operations.384f2d1f.svg";